<template>
      <div class="customl-section">
              <div class="customl-section-header">
                <h3>{{getTranslations('expression_150')}}</h3>
                <button class="customl-add-tag-btn" @click="toggleTagSelector">
                  <span class="customl-plus-icon">+</span> {{getTranslations('expression_514')}}
                </button>
              </div>

              <!-- Loading state -->
              <div v-if="loadingTags" class="customl-tags-loading">
                <div class="customl-spinner"></div>
                <span>{{getTranslations('expression_36')}}</span>
              </div>

              <!-- Seletor de tags não vinculadas -->
              <div v-if="showTagSelector" class="customl-tag-selector">
                <div class="customl-tag-selector-header">
                  <h4>{{getTranslations('expression_1407')}}</h4>
                  <button class="customl-close-tag-selector" @click="toggleTagSelector">
                    <i class="bx bx-x"></i>
                  </button>
                </div>
                <div class="customl-tag-selector-content">
                  <div v-if="unassociatedTags.length > 0" class="customl-tags-list">
                    <div v-for="tag in unassociatedTags" :key="tag.id" @click="addTagToLead(tag.id)"
                      class="customl-tag customl-unassociated-tag">
                      <span class="customl-tag-text">{{ tag.name }}</span>
                      <span class="customl-tag-icon">
                        <i class="bx bx-plus"></i>
                      </span>
                    </div>
                  </div>
                  <div v-else class="customl-no-tags-message">
                    <i class="bx bx-purchase-tag-alt"></i>
                    <span>{{getTranslations('expression_517')}}</span>
                  </div>
                </div>
              </div>

              <!-- Lista de Tags vinculadas - VERSÃO RESPONSIVA -->
              <div v-else class="customl-tags-container">
                <!-- Tags vinculadas - Mostra apenas um número limitado inicialmente -->
                <div v-if="associatedTags.length > 0" class="customl-tags-list">
                  <div v-for="(tag, index) in visibleTags" :key="tag.id" class="customl-tag customl-tag-active">
                    <span class="customl-tag-text">{{ tag.name }}</span>
                    <span class="customl-tag-icon" @click.stop="removeTagFromLead(tag)">
                      <i class="bx bx-x"></i>
                    </span>
                  </div>

                  <!-- Contador de tags adicionais quando há mais tags do que o limite visível -->
                  <div v-if="associatedTags.length > tagsVisibleLimit && !showAllTags"
                    class="customl-tag customl-tag-counter" @click="toggleShowAllTags">
                    <span class="customl-tag-text">+{{ associatedTags.length - tagsVisibleLimit }}</span>
                  </div>
                </div>

                <!-- Botões para expandir/colapsar quando há muitas tags -->
                <div v-if="associatedTags.length > tagsVisibleLimit" class="customl-tags-toggle">
                  <button @click="toggleShowAllTags" class="customl-tags-toggle-btn">
                    <span>{{ showAllTags ? getTranslations('expression_1409') : getTranslations('expression_63')}}</span>
                    <i class="bx" :class="showAllTags ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                  </button>
                </div>

                <!-- Mensagem quando não há tags vinculadas -->
                <div v-if="associatedTags.length === 0" class="customl-no-tags-message">
                  <i class="bx bx-purchase-tag-alt"></i>
                  <span>{{getTranslations('expression_146')}}</span>
                </div>
              </div>
            </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import "../../assets/css/modals/ContactModal.css"
export default {
    name: 'LeadTags',
    props: {
        lead: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loadingTags: false,
            errorLoadingTags: null,
            showTagSelector: false,
            tagsVisibleLimit: 5, // Número de tags visíveis inicialmente
            showAllTags: false,
        }
    },
watch: {
    'lead.id': {  
      immediate: true,
      handler(newLeadId, oldLeadId) {
        if (newLeadId && newLeadId !== oldLeadId) {
          this.loadTags();
        }
      }
    }
},
    computed: {
        ...mapState(['lead_tags', 'notes', 'configs']),
    ...mapGetters([
      'getLeadCampaignsObject',
      'getChannelObject',
      'getLeadTagObject',
      'getLeadTagsArray',
      'getTagsArray',
      'getTranslations'
    ]),
        availableTags() {
      if (!this.lead?.channel_id) return [];
      const tags = this.getTagsArray('channel_id', this.lead.channel_id) || [];
      return tags;
    },

    leadAssociatedTags() {
      if (!this.lead?.id) return [];
      const leadTags = this.getLeadTagsArray('lead_id', this.lead.id) || [];
      return leadTags;
    },

    associatedTags() {
      if (!this.leadAssociatedTags.length || !this.availableTags.length) return [];

      return this.leadAssociatedTags.map(leadTag => {
        const tag = this.availableTags.find(t => t.id === leadTag.tag_id);
        return {
          id: leadTag.id,
          tag_id: leadTag.tag_id,
          name: tag ? tag.name : 'Tag desconhecida'
        };
      });
    },

    unassociatedTags() {
      if (!this.availableTags.length) return [];

      return this.availableTags.filter(tag =>
        !this.leadAssociatedTags.some(leadTag => leadTag.tag_id === tag.id)
      );
    },
    visibleTags() {
      if (this.showAllTags) {
        return this.associatedTags;
      } else {
        return this.associatedTags.slice(0, this.tagsVisibleLimit);
      }
    },
    },
    // mounted() {
    //     if (this.lead?.id) {
    //   this.loadTags();
    // }
    // },
   
    methods: {
    async loadTags() {
      if (!this.lead?.id) return;
      
      this.loadingTags = true;
      this.errorLoadingTags = null;

      try {
        // Carregar apenas as tags do lead específico
        await this.$store.dispatch('getLeadTags', { lead_id: this.lead.id });
      
        //Carrega as tags do canal so se necessario
        if (this.lead.channel_id && this.showTagSelector) {
          await this.$store.dispatch('getTagsAll');
        }
      } catch (error) {
        console.error("Erro ao carregar tags:", error);
        this.errorLoadingTags = error.message;
      } finally {
        this.loadingTags = false;
      }
    },

    async toggleTagSelector() {
      this.showTagSelector = !this.showTagSelector;
      
      // Só carrega todas as tags quando o usuário abrir o seletor
      if (this.showTagSelector && this.lead.channel_id) {
        try {
          await this.$store.dispatch('getTagsAll');
        } catch (error) {
          console.error("Erro ao carregar tags do canal:", error);
        }
      }
    },

    isTagAssociated(tagId) {
      return this.leadAssociatedTags.some(tag => tag.tag_id === tagId);
    },

    async addTagToLead(tagId) {
   
        const payload = {
          channel_id: this.lead.channel_id,
          lead_id: this.lead.id,
          tag_id: tagId
        };

        await this.$store.dispatch('addLeadTag', payload);

        // Fecha o seletor de tags
        this.showTagSelector = false;

        // Feedback visual
      //   this.$swal.fire({
      //     position: 'center',
      //     icon: 'success',
      //     title: 'Tag adicionada!',
      //     showConfirmButton: false,
      //     timer: 1500
      //   });
      // } catch (error) {
      //   console.error("Erro ao adicionar tag:", error);
      //   this.$swal.fire({
      //     icon: 'error',
      //     title: 'Erro',
      //     text: error.response?.data?.message || 'Falha ao adicionar tag',
      //     timer: 2000
      //   });
      //   this.$emit('data-updated');

      // }
  },

    async removeTagFromLead(tag) {
      // try {
        const { isConfirmed } = await this.$swal.fire({
          title: this.getTranslations('expression_887'),
          text: this.getTranslations('expression_888'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: this.getTranslations('expression_421'),
          cancelButtonText: this.getTranslations('expression_355')
        });

        if (!isConfirmed) return;

        await this.$store.dispatch('deleteLeadTag', {
          lead_id: this.lead.id,
          id: tag.id
        });

        // this.$swal.fire({
        //   icon: 'success',
        //   title: 'Tag removida!',
        //   timer: 1500
        // });
      // } catch (error) {
      //   console.error("Erro ao remover tag:", error);
      //   this.$swal.fire({
      //     icon: 'error',
      //     title: 'Erro',
      //     text: error.response?.data?.message || 'Falha ao remover tag',
      //     timer: 2000
      //   });
      //   this.$emit('data-updated');

      // }
    },
    toggleShowAllTags() {
      this.showAllTags = !this.showAllTags;
    },

    async handleLeadChange(newVal) {
      if (newVal?.id) {
        this.contact = newVal;
        this.loadTags();

        if (newVal?.channel_id) {
          this.loadingCustomFields = true;
          await this.$nextTick();
          await this.fetchChannelCustomFields();
          await this.fetchLeadCustomFieldValues();
          this.loadingCustomFields = false;
        }
        // await this.$store.dispatch('getNotes', { lead_id: newVal.id });
      }
    }

    }
}
</script>